module.exports = __webpack_public_path__ + "img/0Q3B2213_BlackMatted_MockedUp.7fe1151e.jpg";